import { FC } from 'react'
import { useNavigate } from 'react-router'
import { ProgressIndicator, StepData } from '@mrshmllw/smores-react'

import { Page } from 'directFlow/types'

import { useDirectFlowPath } from 'src/router/direct-flow'
import { useEventTracking } from 'utils'
import { ExtendedStepData, resolveProgressBarSteps } from 'utils/progressIndicatorHelpers'

const steps: Array<ExtendedStepData> = [
  { label: 'Vehicle', id: Page.VEHICLE, pathlist: ['/vehicle'] },
  { label: 'Drivers', id: Page.DRIVERS, pathlist: ['/drivers'] },
  { label: 'Licence', id: Page.LICENCE, pathlist: ['/licence'] },
  {
    label: 'History',
    id: Page.HISTORY,
    pathlist: [
      '/history',
      'claim-free-discount',
      '/previous-cancellation',
      '/previous-cancellation-year',
    ],
  },
  {
    label: 'Claim Free Discount',
    id: Page.CLAIM_FREE_DISCOUNT,
    pathlist: ['/claim-free-discount'],
    isHidden: true,
  },
  {
    label: 'Previous Insurer Cancelled',
    id: Page.PREVIOUS_CANCELLATION,
    pathlist: ['/previous-cancellation'],
    isHidden: true,
  },
  {
    label: 'Previous Insurer Cancelled Date',
    id: Page.PREVIOUS_CANCELLATION_YEAR,
    pathlist: ['/previous-cancellation-year'],
    isHidden: true,
  },
  { label: 'Usage', id: Page.USAGE, pathlist: ['/usage'] },
  {
    label: 'Quote',
    id: Page.POLICY_START_DATE,
    pathlist: ['/policy-start-date'],
    isHidden: true,
  },
]

export const ProgressBar: FC = () => {
  const path = useDirectFlowPath()
  const navigate = useNavigate()
  const track = useEventTracking()

  const progressBar = resolveProgressBarSteps({
    stepMapping: steps,
    options: {
      ignoredPaths: [
        '/start-quote',
        '/details',
        '/start',
        '/registration',
        '/manual-lookup',
        '/vehicle-found',
        '/save-for-later',
        '/continue-quote',
        '/matched-quote-found',
        '/retrieve-matched-quote',
        '/matched-quote-email-sent',
        '/email-registration',
        '/previous-cancellation',
        '/previous-cancellation-year',
        'claim-free-discount',
        '/resume-from-email',
        '/error',
        '/licence-country',
        '/ncd',
        '/student',
        '/ownership',
      ],
    },
  })

  if (!progressBar) {
    return null
  }

  const handleStepChange = (step: StepData) => {
    switch (step.id) {
      case Page.LICENCE:
      case Page.DRIVERS:
      case Page.VEHICLE:
      case Page.HISTORY:
      case Page.USAGE:
      case Page.POLICY_START_DATE: {
        return navigate(path(step.id))
      }

      default: {
        return
      }
    }
  }

  return (
    <ProgressIndicator
      handleStepChange={handleStepChange}
      currentStep={progressBar.currentStep}
      steps={steps}
      onStepClick={({ currentStepIndex, currentStepState }) => {
        track('progressBar', {
          type: 'Direct flow',
          activeButton: currentStepState !== 'disabled',
          clicked: steps[currentStepIndex].label,
          from: progressBar.currentPath,
        })
      }}
    />
  )
}
